import { cn } from '@anytag/shared-utils';
import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { useAnalyticsInstagramHashtagsFilter } from './hooks';

export interface AnalyticsInstagramHashtagsFilterProps extends Omit<TemplateProps, 'onSubmit'> {
  className?: string;
  defaultHashtagId?: string;
}

export const AnalyticsInstagramHashtagsFilter = ({
  className,
  defaultHashtagId,
  ...restProps
}: AnalyticsInstagramHashtagsFilterProps) => {
  const { filter, setFilterForm } = useAnalyticsInstagramHashtagsFilter();

  return (
    <Filter.Provider
      onSubmit={setFilterForm}
      className={cn('border-b border-border px-4 pt-4 pb-4', className)}
      values={{ ...filter, hashtagId: defaultHashtagId || filter.hashtagId }}
    >
      <Template {...restProps} />
    </Filter.Provider>
  );
};

export * from './schemaTypes';
export { useAnalyticsInstagramHashtagsFilter } from './hooks';
